<script lang="ts">
import { onDestroy, onMount } from "svelte";
import { MediaServerUrl } from "ts-media-server-url";
import { activePage } from "../../router";
import { path } from "../../views/Browser.svelte";
import {
	zoom,
	userId,
	domain,
	objectType,
	objectId,
	modifiers,
	extension,
	importUrl,
	file,
	hasMultipleChanges,
} from "./store";

export let min: number = 10;
export let max: number = 1000;
export let step: number = 10;

let zoomStep = 10;

function zoomIn (e: MouseEvent) {
	$zoom = $zoom + zoomStep;
}

function zoomOut (e: MouseEvent) {
	$zoom = $zoom - zoomStep;
}

function zoom100 (e: MouseEvent) {
	$zoom = 100;
}

let imgPath: string = "";

function browse ( ) {
	$path       = imgPath;
	$activePage = "browser";
}

const msu = new MediaServerUrl();

function msuChange ( ) {
	if (!$hasMultipleChanges) {
		msu.userId     = $userId;
		msu.domain     = $domain;
		msu.objectType = $objectType;
		msu.objectId   = $objectId;
		msu.modifiers  = $modifiers;
		msu.file       = $file;
		msu.extension  = $extension;

		if ($domain === "import") {
			msu.fromImportUrl($importUrl.replace("&resize=4", ""));
		}

		imgPath = msu.toString().replace(/\/[a-zA-Z0-9\-_=\.]+$/, "");
	}
}

let unsubs: Array<() => void> = [];

onMount(( ) => {
	unsubs = [
		userId.subscribe(( ) => msuChange()),
		domain.subscribe(( ) => msuChange()),
		objectType.subscribe(( ) => msuChange()),
		objectId.subscribe(( ) => msuChange()),
		modifiers.subscribe(( ) => msuChange()),
		file.subscribe(( ) => msuChange()),
		extension.subscribe(( ) => msuChange()),
	];
});

onDestroy(( ) => {
	unsubs.forEach((unsub) => {
		unsub();
	})
});
</script>
<div class="row border border-secondary">
	<div class="col-2 mb-1 mt-1">
		<div class="d-inline-block">
			<div class="input-group">
				<button class="btn btn-outline-secondary bg-dark" type="button" on:click={zoomOut}><i class="fas fa-search-minus"></i></button>
				<input type="number" {min} {max} {step} class="form-control bg-dark border-secondary text-white" bind:value={$zoom} id="CanvasBarZoom">
				<button class="btn btn-outline-secondary bg-dark" type="button" on:click={zoomIn}><i class="fas fa-search-plus"></i></button>
				<button class="btn btn-outline-secondary bg-dark" type="button" on:click={zoom100}><i class="fas fa-search"></i> <strong>100%</strong></button>
			</div>
		</div>
	</div>
	<div class="col-10 mb-1 mt-1">
		<div class="input-group">
			<input type="text" class="form-control bg-dark border-secondary text-white" bind:value={imgPath} readonly>
			<button class="btn btn-outline-secondary bg-dark" type="button" on:click={browse}><i class="fas fa-folder-open"></i> <strong>Browse</strong></button>
		</div>
	</div>
</div>
